import styled, { css } from 'styled-components';

import { Media } from '../../assets/Mixins.style';

import {
  Inputbox as commonInputbox,
  Input as commonInput,
} from '../../assets/Common/Inputbox.style';

import { Button as commonButton } from '../../assets/Common/Button.style';

import { Strong as commonStrong } from '../../assets/Common/Strong.style';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 100%;
  padding: 0 0 20px;
  border-bottom: 1px solid ${(props) => props.theme.border};
`;

export const Title = styled.h2`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  cursor: default;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  align-items: stretch;
`;

export const Box = styled.div`
  display: flex;
  width: 100%;

  ${Media.lg`
    flex-direction: column;
  `}
`;

export const Aside = styled.div`
  display: block;
  width: 100%;
  max-width: 276px;
  padding: 40px 20px 0 0;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }

  ${Media.lg`
    max-width: initial;
    padding: 20px 10px;
  `}
`;

export const Main = styled.div`
  display: block;
  width: 100%;
  overflow: auto;
  padding: 40px 40px 0 20px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }

  ${Media.lg`
    padding: 20px 10px 0 10px;
    overflow: initial;
  `}
`;

export const MainInner = styled.div`
  display: block;
  width: 100%;
`;

export const Group = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding: 10px 25px;
  margin-bottom: 30px;
  background: ${(props) => props.theme.background};
  border: 1px solid ${(props) => props.theme.border};
  box-shadow: 0 3px 6px 0 ${(props) => props.theme.shadow};
  border-radius: 4px;

  &:last-of-type {
    margin-bottom: 0;
  }

  ${Media.sm`
    padding: 10px 15px;
  `}
`;

export const GroupTitle = styled.h3`
  display: block;
  width: 100%;
  color: ${(props) => props.theme.color};
  font-size: 26px;
  font-weight: 700;
  cursor: default;
`;

export const GroupInfo = styled.div`
  display: inline-block;
  margin-left: 15px;
`;

export const GroupToggle = styled.button`
  position: absolute;
  top: 10px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  transform: translateX(50%);
  background: ${(props) => props.theme.background};
  color: ${(props) => props.theme.color};
  border: 1px solid ${(props) => props.theme.border};
  box-shadow: 0 3px 10px 0 ${(props) => props.theme.shadow};
  border-radius: 100%;
  outline: none;
  cursor: pointer;

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.35;
    `}
`;

export const GroupToggleIcon = styled.i``;

export const GroupContent = styled.div`
  display: block;
  width: 100%;
  padding: 10px 25px;

  ${Media.sm`
    padding: 10px 0;
  `}
`;

export const GroupBox = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  grid-gap: 25px;

  ${Media.sm`
    grid-template-columns: 1fr;
  `}
`;

export const GroupItem = styled.div`
  display: block;
  width: 100%;
`;

export const Subtitle = styled.h6`
  display: block;
  width: 100%;
  margin-bottom: 15px;
  color: ${(props) => props.theme.color};
  font-size: 18px;
  font-weight: 600;
  cursor: default;
`;

export const Inputbox = styled.div`
  ${commonInputbox}
`;

export const Input = styled.input`
  ${commonInput}
`;

export const InputInfo = styled.span`
  display: block;
  color: ${(props) => props.theme.color};
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  cursor: default;
`;

export const Info = styled.span`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  cursor: default;
`;

export const Table = styled.div`
  display: grid;
  width: 100%;
  grid-gap: 5px;
`;

export const Row = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  box-shadow: 0 3px 10px 0 ${(props) => props.theme.shadow};

  ${(props) =>
    props.head &&
    css`
      border-radius: 0;

      ${Media.sm`
        display: none;
      `}
    `}

  ${Media.sm`
    grid-template-columns: 1fr;
  `}
`;

export const Cell = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  padding: 15px;
  color: ${(props) => props.theme.color};
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  cursor: default;

  ${(props) =>
    props.head &&
    css`
      padding: 10px 15px 0;
      border-radius: 0;
      font-weight: 700;
    `}

  ${(props) =>
    props.right &&
    css`
      justify-content: flex-end;
      ${Media.sm`
        justify-content: center;
      `}
    `}

    ${Media.sm`
    gap: 5px;
  `}
`;

export const Label = styled.span`
  width: 50%;
`;

export const Value = styled.span`
  width: 50%;
`;

export const ActionButton = styled.button`
  ${commonButton}
`;

export const ActionButtonIcon = styled.i``;

export const Strong = styled.strong`
  ${commonStrong}
`;

export const DateLabel = styled.span`
  font-weight: 400;
  * {
    margin-right: 5px;
  }
`;

export const MoreBar = styled.div`
  display: block;
  width: 100%;
  text-align: center;
`;

export const More = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  transition: 0.2s color;
  color: ${(props) => props.theme.color};
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.colorOnHover};
  }
`;

export const MoreIcon = styled.i``;
